import { create } from 'zustand';

interface SignMessageState {
  isOpen: boolean;
  title: string;
  steps: string[];
  activeStep: number;
  message: string;
  loading: boolean;
  error: string | null;
  
  // Actions
  setOpen: (open: boolean) => void;
  setTitle: (title: string) => void;
  setSteps: (steps: string[]) => void;
  setActiveStep: (step: number) => void;
  setMessage: (message: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  nextStep: () => void;
  prevStep: () => void;
  reset: () => void;
}

const initialState = {
  isOpen: false,
  title: '',
  steps: [],
  activeStep: 0,
  message: '',
  loading: false,
  error: null,
};

export const useSignMessageStore = create<SignMessageState>((set, get) => ({
  ...initialState,
  
  setOpen: (isOpen: boolean) => set({ isOpen }),
  
  setTitle: (title: string) => set({ title }),
  
  setSteps: (steps: string[]) => set({ steps, activeStep: 0 }),
  
  setActiveStep: (activeStep: number) => {
    const { steps } = get();
    if (activeStep >= 0 && activeStep < steps.length) {
      set({ activeStep });
    }
  },
  
  setMessage: (message: string) => set({ message }),
  
  setLoading: (loading: boolean) => set({ loading }),
  
  setError: (error: string | null) => set({ error }),
  
  nextStep: () => {
    const { activeStep, steps } = get();
    if (activeStep < steps.length - 1) {
      set({ activeStep: activeStep + 1 });
    }
  },
  
  prevStep: () => {
    const { activeStep } = get();
    if (activeStep > 0) {
      set({ activeStep: activeStep - 1 });
    }
  },
  
  reset: () => set(initialState),
}));

// 创建一个全局实例供外部使用
export const signMessageDialog = {
  setOpen: (open: boolean) => useSignMessageStore.getState().setOpen(open),
  setTitle: (title: string) => useSignMessageStore.getState().setTitle(title),
  setSteps: (steps: string[]) => useSignMessageStore.getState().setSteps(steps),
  setActiveStep: (step: number) => useSignMessageStore.getState().setActiveStep(step),
  setMessage: (message: string) => useSignMessageStore.getState().setMessage(message),
  setLoading: (loading: boolean) => useSignMessageStore.getState().setLoading(loading),
  setError: (error: string | null) => useSignMessageStore.getState().setError(error),
  nextStep: () => useSignMessageStore.getState().nextStep(),
  prevStep: () => useSignMessageStore.getState().prevStep(),
  reset: () => useSignMessageStore.getState().reset(),
};